"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6983],{

/***/ 76983:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "CaregiverSearchDirectory": function() { return /* binding */ CaregiverSearchDirectory; },
  "default": function() { return /* binding */ page_CaregiverSearchDirectory; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@care/navigation/dist/components/CoreGlobalFooter/CoreGlobalFooter.js + 13 modules
var CoreGlobalFooter = __webpack_require__(79976);
// EXTERNAL MODULE: ./src/components/common/IterableBannerSection.tsx + 1 modules
var IterableBannerSection = __webpack_require__(97254);
// EXTERNAL MODULE: ./src/context/searchDirectory/SearchDirectoryDataContext.tsx
var SearchDirectoryDataContext = __webpack_require__(32826);
// EXTERNAL MODULE: ./src/components/feature/searchDirectory/InternalLinkingSection.tsx + 1 modules
var InternalLinkingSection = __webpack_require__(53166);
// EXTERNAL MODULE: ./src/components/feature/searchDirectory/BreadcrumbsSection.tsx
var BreadcrumbsSection = __webpack_require__(38071);
// EXTERNAL MODULE: ./src/components/common/ArticleSection/ArticleSection.tsx
var ArticleSection = __webpack_require__(83845);
// EXTERNAL MODULE: ./src/helpers/getArticlesList.ts
var getArticlesList = __webpack_require__(73006);
// EXTERNAL MODULE: ./src/components/feature/searchDirectory/ReviewsSection/ReviewsSection.tsx + 2 modules
var ReviewsSection = __webpack_require__(3092);
// EXTERNAL MODULE: ./src/components/feature/searchDirectory/FAQSection.tsx
var FAQSection = __webpack_require__(96607);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/Box/Box.js + 1 modules
var Box = __webpack_require__(89609);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/Container/Container.js
var Container = __webpack_require__(32045);
// EXTERNAL MODULE: ./src/components/hooks/useResponsive.tsx
var useResponsive = __webpack_require__(19147);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(61730);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box_Box = __webpack_require__(80822);
// EXTERNAL MODULE: ./src/components/feature/searchDirectory/SearchResults.tsx
var SearchResults = __webpack_require__(53653);
// EXTERNAL MODULE: ./src/components/contexts/PageAttributesContext.tsx
var PageAttributesContext = __webpack_require__(73739);
// EXTERNAL MODULE: ./src/components/contexts/SegmentationFiltersContext.tsx
var SegmentationFiltersContext = __webpack_require__(99207);
// EXTERNAL MODULE: ./src/components/Filters/LocationFilter.tsx
var LocationFilter = __webpack_require__(13866);
// EXTERNAL MODULE: ./src/components/Filters/FiltersPopover.tsx
var FiltersPopover = __webpack_require__(61166);
// EXTERNAL MODULE: ./src/components/Filters/FiltersModal.tsx
var FiltersModal = __webpack_require__(88450);
// EXTERNAL MODULE: ./src/components/SearchResults/Pagination.tsx
var Pagination = __webpack_require__(6551);
// EXTERNAL MODULE: ./src/components/feature/searchDirectory/useSearchResults.ts + 2 modules
var useSearchResults = __webpack_require__(28748);
// EXTERNAL MODULE: ./src/__generated__/globalTypes.ts
var globalTypes = __webpack_require__(79967);
// EXTERNAL MODULE: ./src/constants.ts
var constants = __webpack_require__(42660);
// EXTERNAL MODULE: ./src/components/hooks/useLDClientFlags.tsx
var useLDClientFlags = __webpack_require__(32778);
// EXTERNAL MODULE: ./src/components/feature/searchDirectory/hooks/useSearchAdConfig.tsx
var useSearchAdConfig = __webpack_require__(92401);
// EXTERNAL MODULE: ./src/components/feature/searchDirectory/ProductSchema.tsx
var ProductSchema = __webpack_require__(49366);
// EXTERNAL MODULE: ./src/components/feature/searchDirectory/ItemListSchema.tsx
var ItemListSchema = __webpack_require__(87726);
// EXTERNAL MODULE: ./src/components/feature/searchDirectory/Illustration.tsx + 1 modules
var Illustration = __webpack_require__(85665);
// EXTERNAL MODULE: ./src/components/feature/searchDirectory/NoSearchResults.tsx
var NoSearchResults = __webpack_require__(91195);
// EXTERNAL MODULE: ./src/components/page/CaregiverSearchDirectory/components/CaregiverCard/CaregiverCard.tsx
var CaregiverCard = __webpack_require__(44375);
// EXTERNAL MODULE: ./src/components/page/CaregiverSearchDirectory/helpers/shouldShowUserFilters.ts
var shouldShowUserFilters = __webpack_require__(44514);
;// CONCATENATED MODULE: ./src/components/page/CaregiverSearchDirectory/components/SearchResultsContainer.tsx























var SearchResultsContainer = function(param) {
    var Aside = param.Aside;
    var ref = (0,SearchDirectoryDataContext/* useSearchDirectoryData */.Q)(), seoSegmentationSearchResults = ref.seoSegmentationSearchResults, seoSegmentationDetails = ref.seoSegmentationDetails;
    var ref1 = (0,PageAttributesContext/* usePageAttributes */.l)(), seoSegmentId = ref1.seoSegmentId, searchingFor = ref1.searchingFor;
    var initialCaregiverSearchResults = seoSegmentationSearchResults.caregiverSearchResults, initialFilters = seoSegmentationSearchResults.filters, initialPagination = seoSegmentationSearchResults.pagination;
    var isNationalPage = seoSegmentationDetails.pageType === globalTypes/* SEOSegmentationPageType.NATIONAL */.a6.NATIONAL;
    var showUserFilters = (0,shouldShowUserFilters/* shouldShowUserFilters */.J)(searchingFor ? globalTypes/* SEOSegmentationSearchingFor */.yh[searchingFor] : undefined, constants/* SERVICE_ID_FOR_MEMBER_TO_KEY */.e3[seoSegmentationDetails.serviceIdForMember]);
    var ref2 = (0,react.useState)(false), isVisible = ref2[0], setIsVisible = ref2[1];
    var searchFiltersRef = (0,react.useRef)(null);
    var searchResultRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        var lastScrollY = window.scrollY;
        var observer = new IntersectionObserver(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 1), entry = _param[0];
            var isScrollingDown = window.scrollY > lastScrollY;
            lastScrollY = window.scrollY;
            if (entry.isIntersecting) {
                setIsVisible(true);
            } else if (!entry.isIntersecting && isScrollingDown) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        }, {
            threshold: 0.1
        });
        var currentSearchResult = searchResultRef.current;
        if (currentSearchResult) {
            observer.observe(currentSearchResult);
        }
        return function() {
            if (currentSearchResult) {
                observer.unobserve(currentSearchResult);
                observer.disconnect();
            }
        };
    }, []);
    var isExtraSmallViewport = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.down("sm");
    }); // Mobile Phones
    var isSmallViewport = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.only("sm");
    }); // Small Tablets
    var ref3 = (0,useLDClientFlags/* useLDClientFlags */.y)(), GAMFlag = ref3.SEO_3487_GAM_ADS_SEO_MFE;
    var showGAMAds = (GAMFlag === null || GAMFlag === void 0 ? void 0 : GAMFlag.variationIndex) === 1;
    var adConfig = (0,useSearchAdConfig/* useSearchAdConfig */.Z)(showGAMAds);
    var asideLocation = function() {
        if (isSmallViewport || isExtraSmallViewport) return "TOP";
        return "BOTTOM";
    };
    var ref4 = (0,useSearchResults/* useSearchResults */.s)({
        initialFilters: initialFilters,
        initialPagination: initialPagination,
        seoSegmentId: seoSegmentId,
        isNationalPage: isNationalPage,
        showUserFilters: showUserFilters,
        initialSearchResults: {
            caregiverSearchResults: initialCaregiverSearchResults
        }
    }), filters = ref4.filters, setFilters = ref4.setFilters, pagination = ref4.pagination, caregiverSearchResults = ref4.caregiverSearchResults, pageNumber = ref4.pageNumber, baseHandlePageClick = ref4.handlePageClick, baseFetchResults = ref4.fetchResults;
    var handlePageClick = function(newPage) {
        baseHandlePageClick(newPage, searchResultRef);
    };
    var filtersCtx = (0,react.useMemo)(function() {
        return {
            filters: filters,
            setFilters: function(filterVals) {
                setFilters(filterVals);
            },
            fetchResults: function(filterVals, resetPage) {
                baseFetchResults(filterVals, resetPage, searchResultRef);
            }
        };
    }, [
        filters,
        setFilters,
        baseFetchResults
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SegmentationFiltersContext/* SegmentationFiltersContext.Provider */.$I.Provider, {
        value: filtersCtx,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                item: true,
                xs: 12,
                children: [
                    asideLocation() === "TOP" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Aside, {}),
                    !isExtraSmallViewport && !isSmallViewport && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                        mt: 4,
                        ref: searchFiltersRef,
                        sx: {
                            display: "flex",
                            "& .MuiBox-root": {
                                mb: 0
                            }
                        },
                        children: [
                            isNationalPage && /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationFilter/* default */.Z, {}),
                            showUserFilters && /*#__PURE__*/ (0,jsx_runtime.jsx)(FiltersPopover/* FiltersPopover */.g, {})
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                container: true,
                mt: 4,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        md: 8,
                        children: caregiverSearchResults.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(NoSearchResults/* NoSearchResults */.q, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                    ref: searchResultRef
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                    position: "relative",
                                    children: [
                                        caregiverSearchResults.length >= 3 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Illustration/* Illustration */.Q, {
                                            sx: {
                                                position: "absolute",
                                                right: {
                                                    md: "-325px",
                                                    xl: "-475px"
                                                },
                                                top: {
                                                    md: "650px",
                                                    xl: "500px"
                                                }
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchResults/* SearchResults */.s, {
                                            items: caregiverSearchResults,
                                            renderItem: function(item, i) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CaregiverCard/* CaregiverCard */.O, {
                                                    searchResult: item
                                                }, "product-".concat(i));
                                            },
                                            ads: adConfig
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemListSchema/* ItemListSchema */.Q, {
                                            searchResultType: "CAREGIVER",
                                            caregiverSearchResults: caregiverSearchResults,
                                            totalNumberOfResults: pagination.totalNumberOfResults,
                                            startIndex: pagination.startIndex
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductSchema/* ProductSchema */.z, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination/* default */.Z, {
                                            onPageClick: handlePageClick,
                                            pagination: pagination,
                                            segmentId: seoSegmentId,
                                            pageSelected: pageNumber
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: false,
                        md: 1
                    }),
                    asideLocation() === "BOTTOM" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        md: 3,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Aside, {})
                    })
                ]
            }),
            (isExtraSmallViewport || isSmallViewport) && showUserFilters && /*#__PURE__*/ (0,jsx_runtime.jsx)(FiltersModal/* FiltersModal */.F, {
                isVisible: isVisible
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/page/CaregiverSearchDirectory/components/CaregiverStats.tsx
var CaregiverStats = __webpack_require__(98655);
;// CONCATENATED MODULE: ./src/components/page/CaregiverSearchDirectory/components/section/SearchResultsWithAsideSection.tsx







var SearchResultsWithAsideSection = function() {
    var seoSegmentationDetails = (0,SearchDirectoryDataContext/* useSearchDirectoryData */.Q)().seoSegmentationDetails;
    var ref = (0,useResponsive/* useResponsive */.F)(), isSmallViewport = ref.isSmallViewport, isLargeViewport = ref.isLargeViewport;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        bgcolor: "background.secondary",
        pt: 8,
        pb: 10,
        px: {
            lg: 3
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            maxWidth: "lg",
            disableGutters: isSmallViewport || isLargeViewport,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                container: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: isSmallViewport ? "h1" : "display3",
                            component: "h2",
                            mb: 0,
                            mt: 0,
                            mx: isSmallViewport ? 3 : 0,
                            dangerouslySetInnerHTML: {
                                __html: seoSegmentationDetails.searchResultsHeader
                            },
                            sx: {
                                "& p:first-of-type": {
                                    margin: 0
                                }
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchResultsContainer, {
                        Aside: CaregiverStats/* CaregiverStats */.m
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@mui/material/Container/Container.js
var Container_Container = __webpack_require__(46574);
// EXTERNAL MODULE: ./src/components/feature/searchDirectory/getHeroImage.ts
var getHeroImage = __webpack_require__(99661);
// EXTERNAL MODULE: ./src/components/feature/searchDirectory/BackgroundCheckTrustBadge.tsx
var BackgroundCheckTrustBadge = __webpack_require__(35472);
// EXTERNAL MODULE: ./src/helpers/getDefaultHeroImageLarge.ts
var getDefaultHeroImageLarge = __webpack_require__(80427);
// EXTERNAL MODULE: ./node_modules/sanitize-html/index.js
var sanitize_html = __webpack_require__(91036);
var sanitize_html_default = /*#__PURE__*/__webpack_require__.n(sanitize_html);
// EXTERNAL MODULE: ./node_modules/he/he.js
var he = __webpack_require__(86492);
var he_default = /*#__PURE__*/__webpack_require__.n(he);
// EXTERNAL MODULE: ./src/components/feature/searchDirectory/ZipCodeConversion.tsx
var ZipCodeConversion = __webpack_require__(34664);
// EXTERNAL MODULE: ./src/lib/analyticsHelper.tsx
var analyticsHelper = __webpack_require__(883);
;// CONCATENATED MODULE: ./src/components/page/CaregiverSearchDirectory/components/HeroConversionBox.tsx








var HeroConversionBox = function() {
    var pageData = (0,SearchDirectoryDataContext/* useSearchDirectoryData */.Q)();
    var isLargeViewport = (0,useResponsive/* useResponsive */.F)().isLargeViewport;
    var _seoSegmentationDetails = pageData.seoSegmentationDetails, headline = _seoSegmentationDetails.headline, subHeadline = _seoSegmentationDetails.subHeadline;
    var ctaText = "Get started";
    var handleCtaBtn = function() {
        var amplitudeData = {
            cta_text: ctaText,
            cta_type: "button"
        };
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)("CTA Interacted", amplitudeData);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
        sx: {
            mb: 4
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                component: "h1",
                variant: isLargeViewport ? "display1" : "display2",
                color: "primary",
                sx: {
                    mb: {
                        xs: 2,
                        sm: 3
                    },
                    mt: 0
                },
                dangerouslySetInnerHTML: {
                    __html: sanitize_html_default()(he_default().decode(headline))
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                component: "p",
                variant: "body2",
                mb: 4,
                dangerouslySetInnerHTML: {
                    __html: sanitize_html_default()(he_default().decode(subHeadline.replace(/<\/?p>/g, "")))
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ZipCodeConversion/* ZipCodeConversion */.y, {
                showZipCodeInputField: true,
                handleCtaBtn: handleCtaBtn,
                ctaText: ctaText
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/page/CaregiverSearchDirectory/components/section/HeroSection.tsx








var HeroSection = function() {
    var pageData = (0,SearchDirectoryDataContext/* useSearchDirectoryData */.Q)();
    var serviceId = pageData.seoSegmentationDetails.serviceId;
    var seoSegmentId = (0,PageAttributesContext/* usePageAttributes */.l)().seoSegmentId;
    var ref;
    var heroImage = (ref = (0,getHeroImage/* getHeroImage */.w)({
        seoSegmentId: seoSegmentId,
        serviceId: serviceId
    })) !== null && ref !== void 0 ? ref : (0,getDefaultHeroImageLarge/* getDefaultHeroImageLarge */.A)(pageData.seoSegmentationHeroImage);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container_Container/* default */.Z, {
        maxWidth: "lg",
        sx: {
            mt: {
                xs: 3,
                sm: 6,
                lg: 10
            },
            mb: {
                xs: 6,
                lg: 8
            },
            px: {
                xl: 0
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
            container: true,
            sx: {
                flexDirection: {
                    xs: "column",
                    sm: "row"
                },
                alignItems: {
                    sm: "center"
                }
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                    item: true,
                    sm: 6,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroConversionBox, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                            mb: {
                                xs: 6,
                                sm: 0
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundCheckTrustBadge/* BackgroundCheckTrustBadge */.P, {})
                        })
                    ]
                }),
                heroImage && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    item: true,
                    sm: 6,
                    sx: {
                        flex: {
                            sm: 1
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        component: "img",
                        src: heroImage,
                        alt: "Hero image",
                        sx: {
                            width: "100%",
                            objectFit: "cover",
                            pl: {
                                sm: 4,
                                lg: 6
                            }
                        }
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/page/CaregiverSearchDirectory/index.tsx












var CaregiverSearchDirectory = function(param) {
    var pageData = param.pageData;
    var articlesList = (0,getArticlesList/* getArticlesList */.r)(pageData.seoArticlesList);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchDirectoryDataContext/* SearchDirectoryDataProvider */.z, {
        pageData: pageData,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IterableBannerSection/* IterableBannerSection */.d, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroSection, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchResultsWithAsideSection, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewsSection/* ReviewsSection */.m, {
                searchDirectoryTemplateType: "CAREGIVER"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQSection/* FAQSection */.v, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleSection.ArticleSection, {
                articles: articlesList
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InternalLinkingSection/* InternalLinkingSection */.x, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadcrumbsSection/* BreadcrumbsSection */.L, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CoreGlobalFooter/* default */.Z, {
                variant: "inverse"
            })
        ]
    });
};
/* harmony default export */ var page_CaregiverSearchDirectory = (CaregiverSearchDirectory);


/***/ })

}]);